import { clearPrefetchCache } from "./tabPrefetch";
import { tournamentCache } from "./tournamentCache";

export const refreshSubscribers = new Set();

export const requestTournamentRefresh = (tournamentId) => {
    clearPrefetchCache();
    if (tournamentId && tournamentCache[tournamentId]) {
        delete tournamentCache[tournamentId];
    }
    refreshSubscribers.forEach(cb => cb(tournamentId));
};
